import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditLogComponent } from './audit-log.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AuditLogComponent],
  imports: [
    CommonModule,
    NgxPaginationModule,
    SharedModule,
    TranslateModule
  ]
})
export class AuditLogModule { }
